export default () => {
  return /iPad|iPhone|iPod/.test(window.navigator.userAgent);
};



// WEBPACK FOOTER //
// ./client/app/common/utils/isIOS.js